import { CMSModal } from "@/context";
import Link from "next/link";
import React, { useContext } from "react";
import { twMerge } from "tailwind-merge";

interface HomeCardProps {
  value: number | string;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  loading?: boolean;
  navigation?: any;
}

const HomeCard: React.FC<HomeCardProps> = ({
  value,
  title,
  subtitle,
  children,
  loading = false,
  navigation,
}) => {
  const { theme } = useContext(CMSModal);

  return (
    <Link
      href={navigation || ""}
      className={twMerge(
        "rounded-xl border border-gray-200 p-6 w-full",
        "shadow-sm cursor-pointer",
        "transition-all duration-200",
        "hover:shadow-md hover:scale-[1.02]",
        theme === "dark"
          ? "bg-[#191919] text-gray-100"
          : "bg-white text-[#3b3b3b]",
      )}
    >
      {/* Top Value */}
      <div className="text-center">
        {loading ? (
          <div className="animate-pulse space-y-3 flex flex-col items-center">
            <div className="h-10 w-16 bg-gray-200 rounded"></div>
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-medium">{value}</h2>
            <p className="text-gray-500 mt-1">{title}</p>
          </>
        )}
      </div>

      {/* Divider + Subtitle */}
      {subtitle && (
        <div className="flex items-center gap-3 my-4">
          <div className="flex-1 h-px bg-gray-200" />
          <span className="text-xs text-gray-400 tracking-wider">
            {subtitle}
          </span>
          <div className="flex-1 h-px bg-gray-200" />
        </div>
      )}

      {/* Chart / Content */}
      {loading ? (
        <div className="flex items-end gap-3 h-20 mt-4 animate-pulse">
          <div className="w-6 h-10 bg-gray-200 rounded"></div>
          <div className="w-6 h-14 bg-gray-200 rounded"></div>
          <div className="w-6 h-16 bg-gray-200 rounded"></div>
          <div className="w-6 h-8 bg-gray-200 rounded"></div>
          <div className="w-6 h-12 bg-gray-200 rounded"></div>
        </div>
      ) : (
        children && <div className="mt-4">{children}</div>
      )}
    </Link>
  );
};

export default HomeCard;
